import { Api } from '@axiom/ui';
import type { Opportunity, AfcSubmission } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class OpportunityApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async updateConfidentiality(
    oppId: Opportunity['id'],
    body: Record<string, unknown>
  ) {
    return super.write<{ data: null }>({
      endpoint: `/opportunities/${oppId}/sharing/confidentiality`,
      method: 'PATCH',
      body,
    });
  }

  async deleteContactOpp(
    oppId: Opportunity['id'],
    contactId: NonNullable<AfcSubmission['contacts']>[number]['id']
  ) {
    return super.write<{ data: null }>({
      endpoint: `/opportunities/${oppId}/contacts/${contactId}`,
      method: 'DELETE',
    });
  }
}

export const OpportunityApi = new OpportunityApiClass();
